import './klarna';
import './ideal';
import './p24';
import './bancontact';
import './giropay';
import './eps';
import './multibanco';
import './sepa';
import './sofort';
import './wechat';
import './fpx';
import './becs';
import './grabpay';
import './alipay'
import './afterpay';
import './boleto';
import './oxxo';
import './affirm';
import './blik';
import './konbini';
import './paynow';
import './promptpay';
import './swish';


/**
 *  * = upe @ = segregated
 * affirm *@
 * afterpay *@
 * alipay *@
 * bancontact *@
 * becs *@
 * blik *@
 * boleto *@
 * eps *@
 * fpx *@
 * giropay *@
 * grabpay *@
 * ideal *@
 * klarna *@
 * konbini *@
 * multibanco *@
 * oxxo *@
 * p24 *@
 * paynow *@
 * promptpay *@
 * sepa *@
 * sofort *@
 * swish *@
 * wechat *@
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */